import InvoicePortalSummary from './InvoicePortalSummary';

export default InvoicePortalSummary;
